import React from 'react';
import ReactMarkdown from 'react-markdown';
import { FormattedMessage } from 'react-intl';

const Citation = ({
  BLOCK,
  citations,
  isOCR,
  onPageClick,
}) => {

  return (
    <>
      <div className={`${BLOCK}__message-bubble--message-citation-title`}>
        <FormattedMessage id="chatbot-response.sources" />
      </div>
      {citations.map((citation, index) => {
        const { pageNumber, pageRef, citationText } = citation;
        const displayPageRef = pageRef || pageNumber;

        return (
          <div
            key={index}
            className={`${BLOCK}__message-bubble--citation-container`}
          >
            <div className={`${BLOCK}__message-bubble--citation-content`}>
              {isOCR && displayPageRef && (
                <>
                  <span
                    className={`${BLOCK}__message-bubble--page-link`}
                    onClick={() => onPageClick(displayPageRef)}
                  >
                    <FormattedMessage id="chatbot-response.page-number" values={{ pageNumber: displayPageRef }} />
                  </span>
                  {' '}
                </>
              )}
              <ReactMarkdown>{citationText}</ReactMarkdown>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Citation;
